"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionRoot = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const View_1 = require("../View");
const Root = (0, styled_components_1.default)(View_1.View) `
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    user-select: none;
`;
exports.OptionRoot = react_1.default.forwardRef((_a, ref) => {
    var { spaceHorizontal, spaceLeft, spaceRight, contentMod, disabled } = _a, rest = __rest(_a, ["spaceHorizontal", "spaceLeft", "spaceRight", "contentMod", "disabled"]);
    return (react_1.default.createElement(Root, Object.assign({}, rest, { spaceLeft: spaceLeft || View_1.INDENT.s, spaceRight: spaceRight || View_1.INDENT.m, spaceHorizontal: spaceHorizontal, contentMod: contentMod || View_1.VIEW_CONTENT_MOD.fill, disabled: disabled, ref: ref })));
});
//# sourceMappingURL=OptionRoot.js.map